import { Typography } from "@joonapp/web-shared"
import { useMemo } from "react"
import { useNavigate } from "react-router-dom"

import TodoItem from "./TodoItem"
import useCoachingGroup from "../../hooks/useCoachingGroup"
import { useCoachTodosQuery } from "../../networking/coachTodos/queries"
import { ClientTab } from "../../pages/clients/ClientTabNav"
import { CoachingGroup } from "../../types"
import ClientTag from "../clientTag/ClientTag"

const TodoUserListItem = ({
  coachingGroup,
}: {
  coachingGroup: CoachingGroup
}) => {
  const { client } = useCoachingGroup(coachingGroup)
  const { data: todos } = useCoachTodosQuery()
  const navigate = useNavigate()
  const clientTodos = useMemo(
    () => todos?.filter((todo) => todo.client.id === client?.user.id),
    [todos, client]
  )

  const handleClick = () => {
    navigate(`/${coachingGroup.id}/${ClientTab.MESSAGES}`)
  }

  if (!client || !clientTodos || clientTodos.length === 0) return null

  return (
    <div className="flex flex-col border border-borderPrimary rounded-md bg-white py-3 gap-2">
      <button onClick={handleClick}>
        <div className="flex flex-row gap-2 px-3">
          <ClientTag coachingGroup={coachingGroup} />
          <Typography variant="bodyBold" textAlign="left">
            {client?.user.name} {client?.user.last_name}
          </Typography>
        </div>
      </button>
      <div className="flex flex-col">
        {clientTodos?.map((todo) => (
          <TodoItem key={todo.id} todo={todo} />
        ))}
      </div>
    </div>
  )
}

export default TodoUserListItem
